import { Component, ComponentInterface, Element, h, Host, Prop } from "@stencil/core";

/**
 * @slot (default) - The breadcrumb items.
 */
@Component({
    tag: "uic-accordion",
    styleUrl: "accordion.scss"
})
export class Accordion implements ComponentInterface {
    @Element() host: HTMLUicAccordionElement;

    /**
     * Controls the number of items allowed to be open,
     * either a single one or multiple.
     */
    @Prop() readonly mode: "single" | "multiple" = "single";

    private handleKeyDown(event: KeyboardEvent) {
        if (!(event.target as HTMLElement).classList.contains("uic-accordion-item__header")) {
            return;
        }

        if (!["ArrowDown", "ArrowUp"].includes(event.key)) {
            return;
        }
        event.preventDefault();

        const items = Array.from(this.host.querySelectorAll("uic-accordion-item")).filter((item) => !item.disabled);

        const focusedItem = (event.target as HTMLElement).closest("uic-accordion-item");
        let focusedItemIndex = items.indexOf(focusedItem);
        focusedItemIndex += event.key === "ArrowUp" ? -1 : 1;

        const nextFocusedItem = (focusedItemIndex + items.length) % items.length;
        items[nextFocusedItem].focusHeader();
    }

    private handleShow(e: CustomEvent) {
        if (this.mode === "multiple") {
            return;
        }

        const target = e.target as HTMLUicAccordionItemElement;
        if (target.nodeName.toLowerCase() === "uic-accordion-item") {
            this.hideAllItemsExcept(target);
        }
    }

    private hideAllItemsExcept(target: HTMLUicAccordionItemElement) {
        const allItems = this.host.querySelectorAll("uic-accordion-item");
        allItems.forEach((item) => {
            if (item !== target) {
                item.open = false;
            }
        });
    }

    render() {
        return (
            <Host onUicShow={(e) => this.handleShow(e)} onKeydown={(e) => this.handleKeyDown(e)}>
                <slot></slot>
            </Host>
        );
    }
}
